import { CONST } from '../utils/constants';
import DateUtils from '../utils/dateUtils';

export type TrainerPaymentTypeEnum = 0;
export const TrainerPaymentTypeEnum = {
  HourlyRate: 0 as TrainerPaymentTypeEnum,
};

export interface TrainerPayment {
  id: string;
  name: string;
  type: TrainerPaymentTypeEnum;
  trainerId: string;
  departmentId?: string;
  departmentName?: string;
  dateFrom: string;
  dateTill: string;
  feeEuro: number;
  hours: number;
  costCenter: string;
  hasTrainerHours: boolean;
  lastUpdatedByEmployeeId?: string;
  lastUpdatedDate?: string;
  creatorId?: string;
  createdDate: string;
  companyId: string;
}

export interface Value {
  value: TrainerPayment[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

function toAPI(data: Partial<TrainerPayment>): any {
  return {
    Id: data?.id || CONST.emptyGuid,
    Name: data?.name || '',
    Type: data?.type || TrainerPaymentTypeEnum.HourlyRate,
    TrainerId: data?.trainerId || CONST.emptyGuid,
    DepartmentId: data?.departmentId || undefined,
    DateFrom: data?.dateFrom || DateUtils.getTodayDateAsIsoString(),
    DateTill: data?.dateTill || DateUtils.getTodayDateAsIsoString(),
    FeeEuro: data?.feeEuro || 0,
    Hours: data?.hours ?? 1,
    CostCenter: data?.costCenter || '',
  };
}

function parse(data?: Partial<TrainerPayment>): TrainerPayment {
  const type =
    typeof data?.type == 'string'
      ? data.type
      : getTrainerPaymentTypeText(
          data?.type ?? TrainerPaymentTypeEnum.HourlyRate
        );
  return {
    id: data?.id || '',
    name: data?.name || '',
    type: TrainerPaymentTypeEnum[type as keyof typeof TrainerPaymentTypeEnum],
    trainerId: data?.trainerId || '',
    departmentId: data?.departmentId || undefined,
    departmentName: data?.departmentName || undefined,
    dateFrom: data?.dateFrom || DateUtils.getTodayDateAsIsoString(),
    dateTill: data?.dateTill || DateUtils.getTodayDateAsIsoString(),
    feeEuro: data?.feeEuro || 0,
    hours: data?.hours ?? 1,
    costCenter: data?.costCenter || '',
    hasTrainerHours: data?.hasTrainerHours ?? false,
    lastUpdatedByEmployeeId: data?.lastUpdatedByEmployeeId || undefined,
    lastUpdatedDate: data?.lastUpdatedDate || undefined,
    creatorId: data?.creatorId || undefined,
    createdDate:
      data?.createdDate || DateUtils.getCurrentLocalDateAsIsoString(),
    companyId: data?.companyId || '',
  };
}

export default {
  parse,
  toAPI,
};

export function getTrainerPaymentTypeText(
  type: TrainerPaymentTypeEnum
): string {
  return Object.keys(TrainerPaymentTypeEnum)[
    Object.values(TrainerPaymentTypeEnum).findIndex((entry) => entry == type)
  ];
}
